module.exports = __webpack_public_path__ + "img/home.918dea8c.png";